<button  cdkMonitorElementFocus matRipple matRippleRadius="20" matRippleColor="rgba(0, 0, 0, 0.2)" class="custom-button" [disabled]="disabled" (click)="onClick($event)">
  <ng-content></ng-content>
</button>
